import { render, staticRenderFns } from "./Whells.vue?vue&type=template&id=6bc92a73&scoped=true"
import script from "./Whells.vue?vue&type=script&lang=js"
export * from "./Whells.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc92a73",
  null
  
)

export default component.exports